'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _projects = require('redux/modules/projects');

var projectsActions = _interopRequireWildcard(_projects);

var _reduxConnect = require('redux-connect');

var _reactRouterRedux = require('react-router-redux');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _auth = require('selectors/auth');

var _projects2 = require('helpers/projects');

var _permissions = require('helpers/permissions');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ProjectLegendLine = require('components/ProjectLegendLine/ProjectLegendLine');

var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);

var _ProjectsTabs = require('components/ProjectsTabs/ProjectsTabs');

var _ProjectsTabs2 = _interopRequireDefault(_ProjectsTabs);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Projects.scss');

var Projects = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (projectsActions.isLoadTime(getState())) {
      dispatch(projectsActions.filter(''));
      return (0, _asyncPromise2.default)(dispatch(projectsActions.loadProjects()).promise);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    kw: state.projects.kw,
    permissions: (0, _auth.getPermissions)(state),
    projectType: ownProps.params.type
  };
}, (0, _extends3.default)({}, projectsActions, { pushState: _reactRouterRedux.push, initProject: projectActions.init })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Projects, _Component);

  function Projects() {
    var _ref2;

    (0, _classCallCheck3.default)(this, Projects);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Projects.__proto__ || (0, _getPrototypeOf2.default)(Projects)).call.apply(_ref2, [this].concat(args)));

    _this.state = { kw: _this.props.kw };
    return _this;
  }

  (0, _createClass3.default)(Projects, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.kw !== this.props.kw) {
        this.setState({ kw: nextProps.kw });
      }
    }
  }, {
    key: 'getHeader',
    value: function getHeader() {
      var _headers;

      var _props = this.props,
          t = _props.t,
          projectType = _props.projectType;

      var headers = (_headers = {}, (0, _defineProperty3.default)(_headers, _projects2.projectTypes.audio, t('Audio')), (0, _defineProperty3.default)(_headers, _projects2.projectTypes.video, t('Video')), (0, _defineProperty3.default)(_headers, _projects2.projectTypes.sharespace, t('Sharespaces')), _headers);
      return headers[projectType];
    }
  }, {
    key: 'createNewProject',
    value: function createNewProject() {
      var _props2 = this.props,
          t = _props2.t,
          projectType = _props2.projectType,
          initProject = _props2.initProject,
          pushState = _props2.pushState;

      initProject();
      if (projectType === _projects2.projectTypes.all) {
        pushState('/projects/new');
      } else if (projectType === _projects2.projectTypes.video) {
        _toastr2.default.info(t('Currently Unavailable'));
      } else {
        pushState('/projects/' + projectType + '/0');
      }
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      this.setState({ kw: kw });
      this.props.filter(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          projectType = _props3.projectType,
          permissions = _props3.permissions;
      var kw = this.state.kw;

      var canCreateProject = (0, _permissions.canCreateProjectByType)(permissions, projectType);

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.projects, 'page') },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Projects' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'h1',
              null,
              this.getHeader()
            ),
            _react2.default.createElement(_ProjectsTabs2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { className: styles.headerHint },
            t('Please choose the project or sharespace you want to work on from the list below'),
            '.'
          ),
          _react2.default.createElement(
            'div',
            { className: 'overflow-hidden' },
            _react2.default.createElement(_SearchBar2.default, {
              className: styles.searchBar,
              inputClass: styles.searchInput,
              kw: kw,
              onChange: this.filter
            }),
            _react2.default.createElement(_ProjectLegendLine2.default, { className: styles.legendLine }),
            canCreateProject && _react2.default.createElement(
              _Button2.default,
              { className: 'btn-primary pull-right', onClick: this.createNewProject },
              t('Create new')
            )
          ),
          _react2.default.createElement(_components.ProjectsListWrapper, {
            projectType: projectType,
            showTypeColumn: projectType === 'all',
            showActionsColumn: true
          })
        )
      );
    }
  }]);
  return Projects;
}(_react.Component), _class3.propTypes = {
  filter: _propTypes2.default.func.isRequired,
  initProject: _propTypes2.default.func.isRequired,
  kw: _propTypes2.default.string,
  permissions: _propTypes2.default.object,
  projectType: _propTypes2.default.string,
  pushState: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'createNewProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'createNewProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = Projects;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Projects/Projects.js
// module id = 2205
// module chunks = 1